import { LoyaltySvgIcon, type LoyaltyIconProps } from './LoyaltySvgIcon';

export const PopcornIcon = (props: LoyaltyIconProps): JSX.Element => (
    <LoyaltySvgIcon {...props}>
        <circle cx="7.6" cy="5.6" r="1.9" />
        <circle cx="12" cy="4.4" r="2.1" />
        <circle cx="16.4" cy="5.6" r="1.9" />
        <circle cx="9.8" cy="6.6" r="1.6" />
        <circle cx="14.2" cy="6.6" r="1.6" />
        <path
            fillRule="evenodd"
            d="M5.8 9h12.4l-1.3 12.5H7.1L5.8 9zm3.22 0l.68 12.5h1L10.26 9H9.02zm4.72 0l-.48 12.5h1L14.98 9h-1.24z"
        />
    </LoyaltySvgIcon>
);
